import React, { Component } from 'react'
import Layout from '@components/shared/layout';
import SelecaoAtendimento from '@components/SelecaoAtendimento';
import m from '@utils/strings';
import { connect } from "react-redux";
import userManager from '@utils/userManager';

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.verifiyIfUserIsAuthenticated();
    }

    componentDidMount() {
        this.verifiyIfUserIsAuthenticated();
    }

    componentDidUpdate() {
        this.verifiyIfUserIsAuthenticated();
    }

    verifiyIfUserIsAuthenticated = () => {
        const { user } = this.props
        if (!user || user.expired) {
            userManager.signinRedirect();
        }
    }

    render() {
        const { user } = this.props
        return (
            <div>
                <Layout user={user} content={user ? `${m.JUMBOTRON_AZUL_SUPERIOR.MENSAGEM_BOAS_VINDAS} ${user.profile.given_name} ${user.profile.family_name}` : `Olá ${m.JUMBOTRON_AZUL_SUPERIOR.MENSAGEM_USUARIO_GENERICO}`} />
                <SelecaoAtendimento />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.oidc.user
})

const mapDispatchToProps = (dispatch) => ({
    dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);